<template>
  <a-form-model
    class="part form contract"
    ref="contractForm"
    :model="contract"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :submit="onSubmit"
  >
    <a-form-model-item label="Contract No." prop="contract_number">
      <a-input v-model="contract.contract_number" placeholder="Contract Number" />
    </a-form-model-item>

    <a-form-model-item label="Type" prop="type">
      <a-select v-model="contract.type" default-value="standard">
        <a-select-option value="standard"> Standard Contract </a-select-option>
        <a-select-option value="lump-sum"> Lump Sum Contract </a-select-option>
        <a-select-option value="unit-price"> Unit Price Contract </a-select-option>
        <a-select-option value="cost-plus"> Cost Plus Contract </a-select-option>
        <a-select-option value="incentive"> Incentive Contracts </a-select-option>
        <a-select-option value="percentage"> Percentage of Construction Fee Contracts </a-select-option>
        <a-select-option value="other"> Other </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="Amount" prop="amount">
      <a-input v-model="contract.amount" type="number" placeholder="Contract Amount" />
    </a-form-model-item>

    <a-form-model-item label="Location" prop="location">
      <a-select v-model="contract.location" default-value="office">
        <a-select-option value="office"> Office </a-select-option>
        <a-select-option value="customer-home"> Customer Home </a-select-option>
        <a-select-option value="outside-the-office"> Outside the office </a-select-option>
        <a-select-option value="construction-site"> Construction Site </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="Representative" prop="representative">
      <a-select v-model="contract.representative" default-value="5f305705ed03ced1adf17d48">
        <a-select-option value="5f305705ed03ced1adf17d48"> Justin Trudeau</a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="Effective Date" prop="effective_date">
      <a-date-picker
        v-model="contract.effective_date"
        show-time
        type="date"
        placeholder="Pick an effective date"
        style="width: 100%"
      />
    </a-form-model-item>

    <a-form-model-item label="Has Signed">
      <a-switch v-model="contract.signed" />
    </a-form-model-item>

    <a-form-model-item label="Signed Date" prop="signed_date">
      <a-date-picker
        v-model="contract.signed_date"
        show-time
        type="date"
        placeholder="Pick an signed date"
        style="width: 100%"
      />
    </a-form-model-item>

    <a-form-model-item label="Note" prop="note">
      <a-input v-model="contract.note" type="textarea" :rows="6" placeholder="Contract note" />
    </a-form-model-item>

    <!-- actions -->
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit"> Create </a-button>
      <a-button style="margin-left: 10px"> Cancel </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: 'contract-form',
  data() {
    return {
      contract: {
        signed: false,
        amount: 0,
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      rules: {
        contract_number: [{ required: true, message: 'Please input contract number', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onSubmit() {
      this.$refs.contractForm.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.contract)
        } else {
          console.log('contract error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.contractForm.resetFields()
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.form.contract {
  .checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: left;
    label {
      margin-left: unset;
    }
  }
}
</style>
